<script lang="ts">
    import { Filters } from "./store";
    import ToggleHeader from "./ToggleHeader.svelte";
    import { toggleShowBooks, UI } from "./ui.store";
    import { slide } from "svelte/transition";

    function updateBookFilter(event) {
        Filters.update((filters) => {
            filters.books[event.target.id] = event.target.checked;
            return filters;
        });
        return false;
    }

    function sortedBooks() {
        return Object.keys($Filters.books).sort((a, b) => {
            return a.localeCompare(b);
        });
    }
</script>

<ToggleHeader active={$UI.showBooks} toggleFunction={toggleShowBooks}
    >BOOKS</ToggleHeader
>
{#if $UI.showBooks}
    <div transition:slide={{ duration: 200 }}>
        {#each sortedBooks() as book}
            <label class="checkbox" class:active={$Filters.books[book]}>
                <input
                    type="checkbox"
                    id={book}
                    bind:checked={$Filters.books[book]}
                    on:change={updateBookFilter}
                />
                {book}
            </label>
        {/each}
    </div>
{/if}

<style>
    div {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
</style>
